/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type RadiologistProfileFragment_radiologistProfile$ref = any;
export type RefreshTokenInput = {|
  clientMutationId?: ?string,
  refreshToken: string,
|};
export type RefreshTokenMutationVariables = {|
  input: RefreshTokenInput
|};
export type RefreshTokenMutationResponse = {|
  +refreshToken: ?{|
    +authToken: ?string,
    +authRefreshToken: ?string,
    +authRefreshTokenExpiry: ?number,
    +user: ?{|
      +dbId: number,
      +name: string,
      +type: ?string,
      +radiologistProfile: ?{|
        +$fragmentRefs: RadiologistProfileFragment_radiologistProfile$ref
      |},
    |},
  |}
|};
export type RefreshTokenMutation = {|
  variables: RefreshTokenMutationVariables,
  response: RefreshTokenMutationResponse,
|};
*/


/*
mutation RefreshTokenMutation(
  $input: RefreshTokenInput!
) {
  refreshToken(input: $input) {
    authToken
    authRefreshToken
    authRefreshTokenExpiry
    user {
      dbId
      name
      type
      radiologistProfile {
        ...RadiologistProfileFragment_radiologistProfile
        id
      }
      id
    }
  }
}

fragment RadiologistProfileFragment_radiologistProfile on RadiologistProfile {
  id
  dbId
  gender
  dateOfBirth
  nationality
  country
  city
  street
  examTypeIds
  qualificationCategory
  practiceSince
  personalId
  professionalLicenses
  qualificationCertificates
  examTypes {
    name
    speciality {
      name
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authToken",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authRefreshToken",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authRefreshTokenExpiry",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RefreshTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RefreshTokenPayload",
        "kind": "LinkedField",
        "name": "refreshToken",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RadiologistProfile",
                "kind": "LinkedField",
                "name": "radiologistProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RadiologistProfileFragment_radiologistProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RefreshTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RefreshTokenPayload",
        "kind": "LinkedField",
        "name": "refreshToken",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RadiologistProfile",
                "kind": "LinkedField",
                "name": "radiologistProfile",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gender",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateOfBirth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nationality",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "country",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "street",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "examTypeIds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "qualificationCategory",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "practiceSince",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "personalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "professionalLicenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "qualificationCertificates",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExamType",
                    "kind": "LinkedField",
                    "name": "examTypes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Speciality",
                        "kind": "LinkedField",
                        "name": "speciality",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01f24116f791bb19191c9c186db39a59",
    "id": null,
    "metadata": {},
    "name": "RefreshTokenMutation",
    "operationKind": "mutation",
    "text": "mutation RefreshTokenMutation(\n  $input: RefreshTokenInput!\n) {\n  refreshToken(input: $input) {\n    authToken\n    authRefreshToken\n    authRefreshTokenExpiry\n    user {\n      dbId\n      name\n      type\n      radiologistProfile {\n        ...RadiologistProfileFragment_radiologistProfile\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment RadiologistProfileFragment_radiologistProfile on RadiologistProfile {\n  id\n  dbId\n  gender\n  dateOfBirth\n  nationality\n  country\n  city\n  street\n  examTypeIds\n  qualificationCategory\n  practiceSince\n  personalId\n  professionalLicenses\n  qualificationCertificates\n  examTypes {\n    name\n    speciality {\n      name\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eddae2a8340ff8c8f62f9c911940b8d8';

module.exports = node;
